import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";

import {
  PageOuter,
  PageWrapper,
  HeroBlock,
  Badge,
  Title,
  Accent,
  SliderBlock,
  SliderImg,
  HeroImageWrap,
  HeroImage,
  ContentCard,
  Paragraph,
  LeadParagraph,
} from "./styled";

import { Container } from "../Container/Container";
import { useLocation } from "react-router-dom";
import { useStudie } from "./hook/useStudie";
import { useEffect } from "react";
import { Loader } from "../Loader/Loader";

export const DynamicPageStudies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  const { studie, isLoading } = useStudie({
    slug: location.pathname.split("/")[2],
  });

  if (isLoading || !studie?.title) return <Loader />;

  const otherImages = (studie.otherImages || []).filter(
    (img: any) => img && img.image
  );
  const hasGallery = otherImages.length > 0;

  const paragraphs: string[] = studie.description || [];
  const [lead, ...rest] = paragraphs;

  return (
    <Container>
      <PageOuter>
        <PageWrapper>
          <HeroBlock>
            <Badge>Студия</Badge>
            <Title>{studie.title}</Title>
            <Accent />
          </HeroBlock>

          {hasGallery ? (
            <SliderBlock>
              <Swiper
                pagination={{ clickable: true }}
                modules={[Pagination, Autoplay]}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop
              >
                <SwiperSlide>
                  <SliderImg src={studie.image} alt={studie.title} />
                </SwiperSlide>
                {otherImages.map((img: any, i: number) => (
                  <SwiperSlide key={i}>
                    <SliderImg src={img.image} alt={studie.title} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </SliderBlock>
          ) : (
            <HeroImageWrap>
              <HeroImage src={studie.image} alt={studie.title} />
            </HeroImageWrap>
          )}

          {paragraphs.length > 0 && (
            <ContentCard>
              {lead && <LeadParagraph>{lead}</LeadParagraph>}
              {rest.map((value: string, idx: number) => (
                <Paragraph key={idx}>{value}</Paragraph>
              ))}
            </ContentCard>
          )}
        </PageWrapper>
      </PageOuter>
    </Container>
  );
};
